<template>
  <b-card :title="name"
          style="max-width: 10rem; text-align: center;">
    <div>
      <p v-if="linked">
        <b-button v-on:click="unlinkMethod" variant="danger">Unlink</b-button>
        <b-button v-on:click="relinkMethod" variant="danger">Relink</b-button>
      </p>
      <p v-else>
        <b-button v-on:click="linkMethod" variant="primary">Link</b-button>
      </p>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'AccountLinkCard',
  props: {
    name: String,
    linked: Boolean,
    linkMethod: Function,
    relinkMethod: Function,
    unlinkMethod: Function
  }
}
</script>

<style scoped>

</style>
